// Impressum nach § 5 DDG und § 18 Abs. 2 MStV — Angaben wie auf quantory.de.
import RechtsRahmen from '../komponenten/RechtsRahmen';

export default function Impressum() {
  return (
    <RechtsRahmen titel="Impressum">
      <h2>Anbieter</h2>
      <p>
        Quantory Solutions GmbH<br />
        Hüttenstraße 71<br />
        40215 Düsseldorf<br />
        Deutschland
      </p>

      <h2>Vertreten durch</h2>
      <p>Geschäftsführer: Radwan Salha</p>

      <h2>Kontakt</h2>
      <p>
        Telefon: 01777 317755<br />
        E-Mail: <a href="mailto:info@quantory.de">info@quantory.de</a><br />
        Kontaktformular: <a href="/kontakt">lagerpro.app/kontakt</a>
      </p>

      <h2>Registereintrag</h2>
      <p>
        Registergericht: Amtsgericht Düsseldorf<br />
        Registernummer: HRB 114150
      </p>

      <h2>Umsatzsteuer-Identifikationsnummer</h2>
      <p>Gemäß § 27a Umsatzsteuergesetz: wird nachgereicht.</p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>Radwan Salha, Hüttenstraße 71, 40215 Düsseldorf</p>

      <h2>Verbraucherstreitbeilegung</h2>
      <p>
        Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <h2>Haftung für Inhalte und Links</h2>
      <p>
        Wir erstellen die Inhalte dieser Seiten mit Sorgfalt, übernehmen für Richtigkeit, Vollständigkeit
        und Aktualität jedoch keine Gewähr. Für Inhalte verlinkter fremder Seiten ist allein deren
        Betreiber verantwortlich. Werden uns Rechtsverletzungen bekannt, entfernen wir betroffene
        Inhalte oder Links umgehend.
      </p>
    </RechtsRahmen>
  );
}
